export function updateCountriesAgreements(state, res) {
  const { data = {} } = res;
  state.countriesAgreements = data.items.map((x) => ({ value: x.id, label: x.name, code: x.code }));
}

export function updateCountriesGroupAgreements(state, res) {
  const { data = {} } = res;
  state.countriesGroupAgreements = data.items.map((x) => ({ value: x.id, label: x.name, code: x.code }));
}
